import { useLanguage } from "@/context/LanguageContext";
import { Globe } from "lucide-react";

const languages = [
  { code: "en", name: "English", flag: "🇺🇸" },
  { code: "pt", name: "Português", flag: "🇧🇷" },
  { code: "es", name: "Español", flag: "🇪🇸" }
];

export default function LanguageSwitcher({ variant = "nav" }) {
  const { language, setLanguage } = useLanguage();

  // Compact pill row: all three flags simultaneously visible.
  // Same visual for nav and card, so users always see all options at a glance.
  const containerClasses = variant === "card"
    ? "flex items-center gap-2 p-3 bg-zinc-900/50 border border-zinc-800 rounded-lg"
    : "flex items-center gap-0.5 sm:gap-1.5 shrink-0";

  return (
    <div className={containerClasses} data-testid="language-switcher">
      {variant === "card" && (
        <>
          <Globe className="w-4 h-4 text-cyan-400" />
          <span className="text-sm text-zinc-400">Language:</span>
        </>
      )}
      {languages.map((lang) => {
        const active = language === lang.code;
        return (
          <button
            key={lang.code}
            onClick={() => setLanguage(lang.code)}
            aria-label={`Switch to ${lang.name}`}
            aria-pressed={active}
            title={lang.name}
            className={`flex items-center gap-1 px-1.5 sm:px-2.5 py-1 sm:py-1.5 rounded-full text-sm font-medium transition-all ${
              active
                ? "bg-cyan-500/20 text-cyan-300 border border-cyan-500/50 shadow-sm shadow-cyan-500/20"
                : "bg-zinc-800/50 text-zinc-400 border border-transparent hover:text-white hover:bg-zinc-700/70"
            }`}
            data-testid={`lang-switch-${lang.code}`}
          >
            <span className="text-base sm:text-lg leading-none">{lang.flag}</span>
            <span className="text-xs uppercase tracking-wider hidden sm:inline">{lang.code}</span>
          </button>
        );
      })}
    </div>
  );
}
